import { OrgStatus } from '@constants/generic';
// import { DOCTYPE } from '@features/admin/constants';
import Head from '@layouts/head/Head';

import PendingVerification from '../pending-verification/PendingVerification';
// import RequestRejected from '../request-rejected/RequestRejected';
// import ReuploadDocument from '../reupload-document/ReUpload';

interface OrgPreApprovedStageProps {
  currentOrgStatus?: OrgStatus;
  declarationStatus?: string;
  // documentStatus?: DOCTYPE;
}

const OrgPreApprovedStage = (props: OrgPreApprovedStageProps) => {
  const { currentOrgStatus, declarationStatus } = props;

  const renderContent = () => {
    if (
      currentOrgStatus === OrgStatus.PENDING ||
      currentOrgStatus === OrgStatus.VERIFICATION_SUBMITTED ||
      currentOrgStatus === OrgStatus.REJECTED ||
      (currentOrgStatus === OrgStatus.KYC_SUBMITTED && declarationStatus)
    ) {
      return (
        <>
          <Head
            title={
              currentOrgStatus === OrgStatus.REJECTED
                ? 'Request Rejected'
                : 'Pending Verification'
            }
          />
          <PendingVerification />
        </>
      );
    }

    // if (currentOrgStatus === OrgStatus.REJECTED)
    //   return (
    //     <>
    //       <Head title="Request Rejected" />
    //       <RequestRejected />
    //     </>
    //   );
    return null;
  };

  return (
    <div className="flex h-[calc(100vh-84px)] w-full flex-col items-center justify-center pt-6">
      {renderContent()}
    </div>
  );
};

export default OrgPreApprovedStage;
